<template>
    <chartPage></chartPage>
</template>
  
<script>
import chartPage from '@/views/chart/pages/chart_page.vue';
export default {
    name: "home_whiteboard",
    components: {
        chartPage
    },
};
</script>
  
<style lang="css" scoped>
</style>
  